<script setup lang="ts">
interface SeparatorDotProperties {
  colorClass?: string;
  size?: 's' | 'sm' | 'm';
}

withDefaults(defineProps<SeparatorDotProperties>(), {
  colorClass: 'bg-border',
  size: 'm',
});

const sizeClasses: Record<NonNullable<SeparatorDotProperties['size']>, string> = {
  s: 'h-0.5 w-0.5',
  sm: 'h-0.75 w-0.75',
  m: 'h-1 w-1',
};
</script>

<template>
  <span
    aria-hidden="true"
    :class="['inline-block rounded-full', colorClass, sizeClasses[size]]"
  />
</template>
